import Vue from 'vue';
import SvgIcon from '@/admin/components/SvgIcon/index';

// register globally
Vue.component('svg-icon', SvgIcon);

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);
